import React, { useContext } from "react";
import { Box } from "theme-ui";
import UserContext from "context/User";

import { DashboardOverview } from "./overview";
import ReportsTile from "./overview/ReportsTile";

/**
 * Widget permission keys.
 * Kept in sync with backend `permissions.enum.ts`.
 *
 * MOST OF THESE NO LONGER GATE ANYTHING ON THIS PAGE. The widgets they
 * controlled either moved to /reports and /calendar or were replaced by
 * the overview. The list stays as written because the backend enum and
 * existing role records still carry these keys, and pruning them is a
 * migration rather than a cleanup. Role scoping for the new dashboard is
 * spec 7.6, which is unresolved: Xander seeing AR and Matthew seeing
 * margin are product decisions nobody has made, so this ships with the
 * same visibility everyone had before rather than inventing a rule.
 */
export const DASHBOARD_WIDGET_PERMISSIONS = [
  "dashboardKpiCards",
  "dashboardRevenueTrend",
  "dashboardPipelineFunnel",
  "dashboardExpirationStats",
  "dashboardPipelineMetrics",
  "dashboardOutstandingDeposits",
  "dashboardActivePriceLocks",
  "dashboardRecentActivity",
  "dashboardActionItems",
  "dashboardCalendar",
] as const;

/**
 * CompanyDashboard - the internal dashboard, reduced to what the spec
 * says belongs on it.
 *
 * WHAT CAME OFF, AND WHY IT IS NOT A LOSS:
 * - KPI cards, revenue trend and action items are REPLACED by the
 *   overview. They were not merely duplicates, they were the wrong
 *   numbers: the old cards plot cash and call it revenue, count unsent
 *   drafts as billed, date by createdAt, and exclude no test clients.
 *   Two contradictory revenue figures on one screen is worse than
 *   either alone, because it makes the operator arbitrate.
 * - Pipeline funnel, expiration stats, pipeline metrics, deposits,
 *   price locks and recent activity MOVED to /reports. They are
 *   analysis, not ten-second decisions (spec section 1).
 * - The month calendar MOVED to /calendar. The dashboard carries the
 *   seven-day rail and links across (spec 3.4).
 * - The ACTION REQUIRED BANNER is gone. It was register item 22 defect
 *   4 in person: it said 20 while the queue said 8, because it counts
 *   its own categories with its own rules and filters no test clients.
 *   Two disagreeing counts on one screen make the operator arbitrate,
 *   and the queue now covers every category the banner did (overdue,
 *   due soon, stale quotes, accepted-with-no-project, ordered-with-no-
 *   invoice). One count, one source.
 *
 * Every component still exists in the repo, so putting any of them back
 * is one import and one line.
 */
const CompanyDashboard: React.FC = () => {
  useContext<any>(UserContext);

  return (
    <Box>
      <DashboardOverview />

      <ReportsTile />
    </Box>
  );
};

export default CompanyDashboard;
